import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "intelligence-computations",
  "use": "intelligence-computations-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"intelligence-computations\"><g clip-path=\"url(#intelligence-computations_clip0_2341_11551)\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M36 24h3c3 0 3 3 6.048 10.581C48 42 48 45 51 45h3\" /><path d=\"M33 45c4.5 0 9-6 12-10.5S52.5 24 57 24M4 51.111C4 55.528 5.45 57 9.8 57s5.8-11.778 8.7-26.5C21.4 15.778 22.85 4 27.2 4S33 5.472 33 9.889M9 30.5h18\" /></g><defs><clipPath id=\"intelligence-computations_clip0_2341_11551\"><path fill=\"currentColor\" d=\"M0 0h60v60H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/intelligence-computations.svg
// module id = lyQG
// module chunks = 38 43